"use client";

import { useMediaQuery } from "@trydig/ui/hooks";
import { useState } from "react";
import useKeyboardShortcut from "use-keyboard-shortcut";
import styles from "./DevGrid.module.css";

export const DevGrid = () => {
	const [on, setOn] = useState(false);
	useKeyboardShortcut(["Control", "G"], () => {
		setOn((prev) => !prev);
	});
	const isMobile = useMediaQuery("(max-width: 768px)");
	const count = isMobile ? 6 : 12;

	if (!on) {
		return null;
	}

	return (
		<div className={styles.root}>
			<div className={styles.subgrid}>
				{Array.from({ length: count }).map((_, index) => (
					<div key={index} className={styles.gridItem}>
						{index + 1}
					</div>
				))}
			</div>
		</div>
	);
};
